import { action } from 'easy-peasy';
import { ISetSheltersAction } from '../types';

const setShelters: ISetSheltersAction = action((state, payload) => {
  const { items, pagination } = payload;

  if (pagination) {
    state.pagination.total = pagination.total;
    state.pagination.pageNumber = pagination.pageNumber;
    state.pagination.pageSize = pagination.pageSize;
  }

  state.list = items;
});

export default setShelters;
